export function getTimeView(date) {
	const now = date ? new Date(date) : new Date();
	const hours = now.getHours().toString().padStart(2, '0');
	const minutes = now.getMinutes().toString().padStart(2, '0');
	return time = `${hours}:${minutes}`;
}

export function getCurrentDateTime() {
	const now = new Date();

	const pad = n => n.toString().padStart(2, '0');

	const year = now.getFullYear();
	const month = pad(now.getMonth() + 1); // Месяцы от 0 до 11
	const day = pad(now.getDate());

	const hours = pad(now.getHours());
	const minutes = pad(now.getMinutes());
	const seconds = pad(now.getSeconds());

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function genMsgId() {
	return "msgid" + (new Date()).getTime();
}
